"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
function default_1(paymentDetail) {
    const { order_status_cd_id, room_buyer_modify } = paymentDetail;
    return (order_status_cd_id === 'ORDER_STATUS_01' ||
        ((0, _1.isPaymentDetailTransferable)(paymentDetail) && room_buyer_modify));
}
exports.default = default_1;
